import { gql } from '__generated__';

export default gql(`
  query GetGeneratedEventDescription($project_id: ID!, $input: GenerateEventDescriptionInput!) {
    project(id: $project_id) {
      id
      generated_event_description(input: $input) {
        description
        usp_facts
        whats_included_facts
      }
    }
  }
`);
